import { NavLink, useLocation } from "react-router-dom";
import { useAuth } from "../../config/utilities/useAuth";
import { SIDEBAR_NAV_ITEMS } from "../../config/navConfig";
import "./Sidebar.css";
import SidebarExternalApps from "./SidebarExternalApps";

const SidebarNavLinks = ({ onNavigate = () => {} }) => {
  const { privilege } = useAuth();
  const modules = privilege?.modules;
  const role = privilege?.role;
  const location = useLocation();

  const getAccessiblePath = (item) => {
    if (item.allowedRoles) {
      const hasAccess = item.allowedRoles.includes(role);
      if (!hasAccess) return null;
      return item.primaryPath;
    }

    if (item.moduleKeys && item.moduleKeys.length > 0) {
      const path = [item.primaryPath, ...(item.alternatePaths || [])].find(
        (path, index) => modules?.[item.moduleKeys?.[index]]
      );
      return path;
    }

    return item.primaryPath;
  };

  return (
    <ul className="sidebar-nav-list">
      {SIDEBAR_NAV_ITEMS
        .map((item) => {
          const accessiblePath = getAccessiblePath(item);
          if (!accessiblePath) return null;
          return { ...item, path: accessiblePath };
        })
        .filter(Boolean)
        .map((item) => (
          <li key={item.primaryPath} className="sidebar-nav-item">
            <NavLink
              to={item.path}
              onClick={onNavigate}
              className={({ isActive }) =>
                isActive ||
                [item.primaryPath, ...(item.alternatePaths || [])].includes(
                  location.pathname
                )
                  ? "sidebar-nav-link active"
                  : "sidebar-nav-link"
              }
            >
              <img
                src={item.icon}
                alt={item.name}
                className="sidebar-nav-icon"
              />{" "}
              {item.name}
            </NavLink>
          </li>
        ))}

      <SidebarExternalApps onNavigate={onNavigate} />
    </ul>
  );
};

export default SidebarNavLinks;
